import React from 'react';
import candidaData from '../data/reportData'; // Adjust path if necessary

const Para = ({ type, result }) => {
  // Normalize type and result to lowercase for case-insensitive matching
  const normalizedType = type ? type.toLowerCase() : '';
  const normalizedResult = result ? result.toLowerCase() : '';

  // Check if type is "report"
  if (normalizedType === 'report') {
    return (
      <div  className="w-full pb-[40px] font-poppins bg-violet-100 rounded-2xl px-4 py-3 flex justify-center items-center mt-5 text-sm">
        {candidaData.report[0]}
      </div>
    );
  }

  // Find the key in candidaData that matches normalizedType
  const dataKey = Object.keys(candidaData).find(
    (key) => key.toLowerCase() === normalizedType
  );

  // Safely access candidaData using dataKey and result conditions
  const data = dataKey
    ? (normalizedResult === 'not detected' ? candidaData[dataKey][0] : candidaData[dataKey][1])
    : "Data not available";

  return (
    <div className="w-full pb-[40px] font-poppins bg-violet-100 rounded-2xl px-4 py-3 flex justify-center items-center mt-5 text-sm">
      {data}
    </div>
  );
};

export default Para;
